const $doc = $(document);

$('.js-contact-form').on('submit', function(e) {
  const $this = $(this);
  const $checkbox = $this.find('.js-prevent');

  if (!$checkbox.prop('checked')) {
    e.preventDefault();

    $checkbox.addClass('error');
  }
})

$('.js-prevent').on('change', function() {
  const $this = $(this);

  $this.removeClass('error');
})